import {
  AppointmentStatusLabel,
  BackBreadcrumbItem,
  TooltipLabel,
} from '@eluve/blocks';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
  DetailsSidebarTrigger,
  HStack,
  Header,
  NewButton,
  SidebarTrigger,
} from '@eluve/components';
import { ChatWithPatientData } from '@eluve/feature-chat-with-patient-data';
import {
  useAppointmentHeaderDetails,
  useAppointmentName,
} from '@eluve/frontend-appointment-hooks';
import { useAssignedTenantIdFromParams } from '@eluve/session-helpers';
import { TenantOrUserFeatureFlaggedComponent } from '@eluve/smart-blocks';

import { appConfig } from '../../../../../../config';
import { NewAppointmentButton } from '../../components/NewAppointmentButton';
import { OverviewBreadcrumbItem } from '../../components/OverviewBreadcrumbItem';

export const AppointmentHeader: React.FC = () => {
  const appointmentHeaderDetails = useAppointmentHeaderDetails();
  const appointmentName = useAppointmentName();
  const tenantId = useAssignedTenantIdFromParams();

  return (
    <Header>
      <HStack>
        <SidebarTrigger />
        <Breadcrumb className="flex-1 overflow-hidden">
          <BreadcrumbList>
            <BackBreadcrumbItem />
            <OverviewBreadcrumbItem />
            <BreadcrumbSeparator className="hidden sm:block">
              /
            </BreadcrumbSeparator>
            <BreadcrumbItem className="hidden truncate text-text-primary sm:block">
              {appointmentName}
            </BreadcrumbItem>
            <BreadcrumbItem className="hidden truncate pl-2 text-text-primary sm:block">
              {appointmentHeaderDetails && (
                <AppointmentStatusLabel
                  isSigned={appointmentHeaderDetails.isSigned}
                  isSummarized={appointmentHeaderDetails.isSummarized}
                  status={appointmentHeaderDetails.status}
                  isAmending={appointmentHeaderDetails.isAmending}
                  isAmended={appointmentHeaderDetails.isAmended}
                  size="xs"
                />
              )}
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </HStack>
      <HStack justify="end" wFull={false}>
        <TenantOrUserFeatureFlaggedComponent flag="INSIGHTS_CHAT">
          {appointmentHeaderDetails?.patientId ? (
            <ChatWithPatientData
              // If patient is switched on an appointment, we want to remount the component
              // to prevent previous threads be applied for new patient
              key={appointmentHeaderDetails.patientId}
              tenantId={tenantId}
              patientId={appointmentHeaderDetails.patientId}
              baseUrl={appConfig.VITE_API_DOMAIN}
            />
          ) : (
            <TooltipLabel
              label="Please select a patient first!"
              tooltipContentProps={{ align: 'end', alignOffset: -8 }}
            >
              <NewButton
                disabled
                icon={{ name: 'MessageSquare' }}
                type="outline"
              />
            </TooltipLabel>
          )}
        </TenantOrUserFeatureFlaggedComponent>
        <NewAppointmentButton />
        <DetailsSidebarTrigger>
          <NewButton icon={{ name: 'User' }} type="outline" />
        </DetailsSidebarTrigger>
      </HStack>
    </Header>
  );
};
